import React, { useState, useEffect, Suspense, lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { logout } from '../Helpers/Routers_helper';
import { verificaImgPerfil } from '../Helpers/General_helper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Menu from '../Components/Menu';
import Modal from 'react-bootstrap/Modal';
import Loader from '../Components/Loader';
const Contenido = lazy(() => import('../Pages/Contenido'));
const Usuarios = lazy(() => import('../Pages/Usuarios'));
const UsuarioSubrogante = lazy(() => import('../Pages/UsuarioSubrogante'));
const Carteras = lazy(() => import('../Pages/Carteras'));
const Iniciativas = lazy(() => import('../Pages/Iniciativas'));
const Mantenedores = lazy(() => import('../Pages/Mantenedores'));
const IniciativasDetalle = lazy(() => import('../Pages/Iniciativas/IniciativasDetalle'));
const ReporteIniciativasActivas = lazy(() => import('../Pages/Reportes/ReporteIniciativasActivas'));
const ReporteActividadesIniciativa = lazy(() => import('../Pages/Reportes/ReporteActividadesIniciativa'));
const TareasFechas = lazy(() => import('../Pages/Mantenedores/FechasTareas/TareasFechas'));

export const DashboardRoutes = ({ history, setStateSesion }) => {
    const [state, setState] = useState({
        colaps: false,
        // dataMenu: false,
        colapsFooter: true
    });

    const { colaps, colapsFooter } = state;

    const [ stateImagenPerfil, setStateImagenPerfil ] = useState({
        loading : true,
        imagen : false
    });

    const [userDataState] = useState({
        user_name : localStorage.getItem('usuario'),
        cargo : localStorage.getItem('cargo')
    });

    const handleColaps = () => {
        setState({
            ...state,
            colaps: (colaps ? false : true)
        })
    };

    const handleClickColapsFooter = () => {
        setState({
            ...state,
            colapsFooter: (colapsFooter ? false : true)
        })
    }

    const handleLogOut = () => {
        setStateSesion(false);
        localStorage.setItem('logueado', 'false');
        localStorage.setItem('usuario', '');
        history.replace('/Login');
        logout();
    }

    useEffect(() => {
        verificaImgPerfil().then(data_return => {
            setStateImagenPerfil({
                loading : false,
                imagen : data_return.data
            })
        })
    }, [])

    // const failLogout = () => {
    //     console.log('Error Logout');
    // }

    return (
        <>
        <div className="grid-container">
            <div className={colaps ? "mainMenu colaps" : "mainMenu"}>
                <div className="grid-menu">
                    <div className="menu-principal">
                        <Menu colapsState={colaps} colapsEvent={handleColaps} />
                    </div>
                    {/* <div className="menu-logout"><FontAwesomeIcon icon={faPowerOff} /> */}
                        {/* <GoogleLogout
                            clientId="209478181223-0j3rk8qkb8f5qrd8opkdcq29adm0m16s.apps.googleusercontent.com"
                            buttonText="Logout"
                            onLogoutSuccess={handleLogOut}
                            onFailure={failLogout}
                        >
                        </GoogleLogout> */}
                    {/* </div> */}
                    <div className="menu-logout" onClick={handleLogOut}><FontAwesomeIcon icon={['fad', 'power-off']} /></div>
                    <div className="menu-colaps" onClick={handleColaps}><FontAwesomeIcon icon={['fad', 'chevron-double-left']} className="icono-colaps" /></div>
                </div>
            </div>
            <div className="mainHeader">
                <div className="grid-header">
                    <div className="header-area">
                        <div className="header-container">
                            {/* <select className="listbox-header">
                                <option value="1" >Area Tecnica</option>
                                <option value="2">Area Administrativa</option>
                            </select> */}
                        </div>
                    </div>
                    <div className="header-rol">
                        <div className="header-container">
                            {/* <select className="listbox-header">
                                <option value="11">Rol Administrador</option>
                                <option value="22">Coordinador de Gestion</option>
                                <option value="33">Rol Profesional Tecnico</option>
                                <option value="44">Rol Profesional de Gestion</option>
                                <option value="55">Rol Coordinador Tecnico</option>
                                <option value="66">Rol Jefatura</option>
                            </select> */}
                        </div>
                    </div>
                    <div className="header-img">
                        <div className="header-container">
                            {
                                stateImagenPerfil.loading === false
                                &&
                                <img src={require(`../assets/img/Avatares/${stateImagenPerfil.imagen}`).default} alt="Imagen Usuario" height="55" width="55" />
                            }
                            <div className="contenedor-info-usuario">
                                <div className="span-nombre-usuario">{userDataState.user_name}</div>
                                <div className="span-rol-usuario">{userDataState.cargo}</div>
                            </div>
                            <div className="btn-menu-usuario">
                                <FontAwesomeIcon icon={['fad' ,'paper-plane']} style={{"marginRight" : "0.2rem"}} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="main">
                <Suspense fallback={<Loader />}>
                    <Switch>
                        {/* Menus principales inscritos en el menu lateral */}
                        <Route path="/Contenido" component={Contenido} />
                        <Route path="/Usuarios" component={Usuarios} />
                        <Route path="/UsuarioSubrogante" component={UsuarioSubrogante} />
                        <Route path="/Carteras" component={Carteras} />
                        <Route path="/Iniciativas" component={Iniciativas} />
                        <Route path="/ReporteIniciativasActivas" component={ReporteIniciativasActivas} />
                        <Route path="/ReporteActividadesIniciativa" component={ReporteActividadesIniciativa} />
                        <Route path="/Mantenedores" component={Mantenedores} />

                        {/* Sub menu no inscrito en el menu lateral */}
                        {/* IniciativasDetalle : muestra el detalle de una iniciativas en pestañas [contrato, ejecucion, InfoGeneral, Postulacion ... etc] */}
                        <Route path="/IniciativasDetalle" component={IniciativasDetalle} />
                        <Route path="/TareasFechas" component={TareasFechas} />
                        <Redirect to="/Contenido" />
                    </Switch>
                </Suspense>
                <div className="divResponsiveFooter d-none">
                    <button className="btn-colaps-footer shadow" onClick={handleClickColapsFooter}><FontAwesomeIcon icon={('fad','bars')} /></button>
                </div>
            </div>
            <div className={colapsFooter ? "footResp" : "footResp uncolaps-footer"}>
                <div className="row mt-5">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <select className="form-control">
                            <option value="2344">Seleccione Area</option>
                            <option value="32455">Area Tecnica</option>
                            <option value="984">Area Administrativa</option>
                        </select>
                    </div>
                </div>
                <div className="row mt-5">
                    <div className="col-lg-12 col-md-12 col-sm-12">
                        <select className="form-control">
                            <option value="122">Seleccione Rol</option>
                            <option value="133">Rol Administrador</option>
                            <option value="1144">Coordinador de Gestion</option>
                            <option value="155">Rol Profesional Tecnico</option>
                            <option value="166">Rol Profesional de Gestion</option>
                            <option value="177">Rol Coordinador Tecnico</option>
                            <option value="188">Rol Jefatura</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            show={false}
            // onHide={}
            aria-labelledby="mdl_usr_card"
            centered
            dialogClassName="modal-carta-usuario"
            backdropClassName="backdrop-carta-usuario"
        >
            <Modal.Body>
                <div className="wraper-info-card-usr">
                    <h4>Tu opinion nos importa! 😊</h4>
                </div>
            </Modal.Body>
        </Modal>
        </>
    )
}
